import { render, staticRenderFns } from "./GenitorSVNascimento.vue?vue&type=template&id=3145928a&"
import script from "./GenitorSVNascimento.vue?vue&type=script&lang=js&"
export * from "./GenitorSVNascimento.vue?vue&type=script&lang=js&"
import style0 from "./GenitorSVNascimento.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports